/**
 * @generated SignedSource<<eeadcc7741ea0fd574185ff5a315a90a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BeforeFirstCell$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DragActionsButton">;
  readonly " $fragmentType": "BeforeFirstCell";
};
export type BeforeFirstCell$key = {
  readonly " $data"?: BeforeFirstCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"BeforeFirstCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isReparentingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "BeforeFirstCell",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isReparentingEnabled",
          "variableName": "isReparentingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "DragActionsButton"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "d1920122b2b0817175f76ece2fba87d5";

export default node;
